import styled from 'styled-components';
import Colors from '../../../../../config/Colors';

export const ItemListContainer = styled.div`
    height: 28px;
    width: fit-content;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
    background-color: ${Colors.lighter};
    border-radius: 4px;
    border: 1px solid ${Colors.border};
    padding: 1px 6px;
    margin: 15px 5px 15px 5px;

    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const TextContainer = styled.div`
    display: flex;
`;

export const Text = styled.span`
    font-size: 1.4rem;
    margin: 0 10px 0 5px;
    display: flex;
    flex: 7;
    color: ${Colors.dark};
    font-family: ${({ bold }) =>
        bold ? 'NunitoSans-Bold' : 'NunitoSans-Regular'};
`;

export const X = styled.span`
    align-self: center;
    font-family: NunitoSans-Regular;
    font-size: 1.4rem;
    color: ${Colors.dark};
`;

export const Exclude = styled.button`
    height: 25px;
    min-width: 25px;
    margin: 0;
    padding: 0;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: none;

    &:hover {
        border: 1px solid ${Colors.border};
        background-color: ${Colors.border};
        cursor: pointer;
    }
`;

export const ItemInfoText = styled.span`
    font-family: NunitoSans-Regular;
    font-size: 1.8rem;
`;
